import { useContext, useState, useCallback, useEffect } from "react";
import { isNullOrUndefined } from "utils/validations";
import { setItemLocalStorage } from "utils/localStorage";
import { SUBMENU_EXPEDIENT_CONSULT_BOOLEAN } from "constants/securityConst";
import { HttpStatus } from "utils/enums";
import useTrd from "hooks/useTrd";
import Context from "contextAPI/UserContext";

const useShowConsultExpedient = () => {
  const { getTreeExist } = useTrd();
  const { firstExecution, setFirstExecution, subMenuExpedientConsult } = useContext(Context);
  let viewSubMenuExpedientConsult = false;
  const [firsViewExpedientConsult, setFirstViewExpediente] = useState(null);
  const [isViewExpedientConsult] = useState(() => {
    if (isNullOrUndefined(subMenuExpedientConsult) === false) {
      return subMenuExpedientConsult;
    } else {
      return false;
    }
  });

  if (!isNullOrUndefined(firsViewExpedientConsult)) {
    viewSubMenuExpedientConsult = firsViewExpedientConsult;
  } else {
    viewSubMenuExpedientConsult = isViewExpedientConsult;
  }

  /**
   * Retrieves the existing tree data based on a search.
   * Uses the useCallback hook to memoize the function.
   * @return {Promise} A promise that resolves with the existing tree data.
   */
  const getTreeExistBySearch = useCallback(() => {
    getTreeExist()
      .then((response) => {
        setItemLocalStorage(SUBMENU_EXPEDIENT_CONSULT_BOOLEAN, response.data);
        setFirstViewExpediente(response.data);
      })
      .catch((error) => {
        if (error.response && error.response.status === HttpStatus.UNAUTHORIZED) {
          return;
        }
      });
  }, [getTreeExist]);

  /**
   * useEffect hook that fetches existing tree data based on a search on the first execution.
   * After fetching the data, it updates the 'FIRST_EXECUTION_BOOLEAN' in localStorage to mark subsequent executions.
   * @param {function} getTreeExistBySearch - A function that retrieves existing tree data based on a search criteria.
   * @returns {void} No return value.
   */
  useEffect(() => {
    if (isNullOrUndefined(firstExecution) === false && firstExecution === true) {
      getTreeExistBySearch();
      setFirstExecution(false);
    }
  }, [getTreeExistBySearch]);

  return {
    viewSubMenuExpedientConsult,
    getTreeExistBySearch,
  };
};

export default useShowConsultExpedient;
